// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-spinner {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.page-spinner ion-spinner {\n  transform: scale(4);\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
